<script lang="ts">
  import type { TestAttemptStore } from 'shared/src/user/tests/checkpoint.attempt.store';
  import { autorun } from 'mobx';
  import Dot from '$lib/components/Dot.svelte';
  import { onDestroy } from 'svelte';
  import { dateString, dateTimeString } from 'shared/src/utils/date.utils';
  export let attempt: TestAttemptStore;
  export let index: number;
  let props: {
    score: number;
    updatedAt: Date;
    checkpointId: string;
    id: string;
    isLate: boolean;
    gradePenalty: number;
  };
  const destroyer = autorun(() => {
    props = {
      score: attempt.score,
      updatedAt: new Date(attempt.record.updatedAt),
      id: attempt.id,
      checkpointId: attempt.checkpointId,
      isLate: attempt.isLate,
      gradePenalty: attempt.gradePenalty,
    };
  });

  onDestroy(destroyer);
</script>

<div class="text-xs text-gray-light">
  <span class={props.score >= 80 ? 'text-green' : props.score < 30 ? 'text-red' : 'text-orange'}
    ><Dot /></span
  >
  <a href="/app/checkpoints/{props.checkpointId}/attempts/{props.id}" class="hover:underline">
    #{index + 1}
    {dateString(new Date(props.updatedAt))} at {dateTimeString(new Date(props.updatedAt))} –
    {Math.round(props.score)}%
  </a>
  {#if props.isLate && props.gradePenalty}
    (late, {props.gradePenalty}% deduction)
  {/if}
  {#if props.isLate && !props.gradePenalty}
    (late)
  {/if}
</div>
